module.exports = __webpack_public_path__ + "img/387.98e303bd.png";